import React, { useEffect, useRef, useState } from "react";
import {
  ContentContainer,
  Text,
  Row,
  ButtonBack,
  Buttons,
  Category,
  Value,
  RowCategory,
  Categories,
  AddCategoryContainer,
  Input,
  IconsContainer,
  RowInputBig,
  Relative,
  DropDown,
  DropDownValue,
  DropDownMenu,
  Attributes,
  DivColumn,
  StyledRow,
  StyledColumn,
} from "./CategoriesPage.styles";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Add } from "../../../../assets/icons/add-filled.svg";
import { ReactComponent as Drag } from "../../../../assets/icons/drag.svg";
import UseAnimations from "react-useanimations";
import trash2 from "react-useanimations/lib/trash2";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { toast } from "react-toastify";
import {
  createCategory,
  deleteCategory,
  editCategory,
  updateCategoryPriority,
} from "../../../../store/slices/marketplace/asyncThunks";
import {
  selectCreateCategoryPending,
  selectDeleteCategoryPending,
  selectEditCategoryPending,
  setCategories,
} from "../../../../store/slices/marketplace/marketplaceSlice";
import { ReactComponent as EditPencil } from "../../../../assets/icons/edit-pencil.svg";

import ButtonComponent from "../../../../components/ButtonAdd/ButtonAdd";
import { useGetCategoriesQuery } from "../../../../store/slices/marketplace/marketplaceApi";
import { api } from "../../../../store/api";
import openToast from "../../../../utils/toast";
import AppLoader from "../../../../components/AppLoader";

import { ReactComponent as Chevron } from "../../../../assets/icons/chevronDown.svg";
import { IconContainer } from "../../../../components/Modal/ProfileModal.styles";

const CategoryStep1 = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState("");
  const [newCategoryNameAr, setNewCategoryNameAr] = useState("");
  const [editFormShow, setEditFormShow] = useState(false);
  const [editingCategoryId, setEditingCategoryId] = useState(null);
  const [categoryName, setCategoryName] = useState("");
  const [categoryNameAr, setCategoryNameAr] = useState("");
  const createCategoryLoading = useSelector(selectCreateCategoryPending);
  const editCategoryLoading = useSelector(selectEditCategoryPending);
  const deleteCategoryLoading = useSelector(selectDeleteCategoryPending);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const toastId = useRef(null);
  const [open, setOpen] = useState(false);

  const [subcategories, setSubcategories] = useState([]);

  const { data: categories, isFetching: categoriesPending } =
    useGetCategoriesQuery({ search: "" });

  const allCategories = categories?.data?.categories || [];

  const availableSubcategories = allCategories.filter((cat) => {
    if (editingCategoryId && cat.id === editingCategoryId) return false;

    if (subcategories.some((s) => s.id === cat.id)) return false;

    if (cat.parentId) return false;

    if (cat.subcategories && cat.subcategories.length > 0) return false;

    return true;
  });

  const handleDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const { source, destination } = result;
    const updatedCategories = [...categories?.data?.categories];

    const [movedCategory] = updatedCategories.splice(source.index, 1);
    updatedCategories.splice(destination.index, 0, movedCategory);

    const newPriorities = updatedCategories.map((category, index) => ({
      priority: index,
      categoryId: category.id,
    }));
    dispatch(setCategories(updatedCategories));
    dispatch(updateCategoryPriority({ newPriorities: newPriorities }))
      .unwrap()
      .then(() => {
        dispatch(api.util.invalidateTags(["categories"]));
      })
      .catch((err) =>
        openToast(toastId, "update-category-priority", "error", t(err.message)),
      );
  };

  const handleCategoryDelete = (categoryId) => {
    setSelectedCategory(categoryId);
    dispatch(deleteCategory(categoryId))
      .unwrap()
      .then(() => {
        setSelectedCategory(categoryId);
        toast.success(t("category-deleted-successfully"));
        dispatch(api.util.invalidateTags(["categories"]));
      })
      .catch((error) => {
        console.log(error);
        openToast(toastId, "delete-category", "error", t(error.message));
      });
  };

  const handleAddCategory = () => {
    if (!newCategoryName && !newCategoryNameAr) {
      openToast(toastId, "add-category", "error", t("fill-category-name"));
      return;
    }
    const formattedSubcategories = [];
    if (subcategories) {
      subcategories.map((sub) => {
        formattedSubcategories.push(sub.id);
      });
    }

    dispatch(
      createCategory({
        name: newCategoryName,
        nameAr: newCategoryNameAr,
        ...(subcategories.length && { subcategories: formattedSubcategories }),
      }),
    )
      .unwrap()
      .then(() => {
        toast.success(t("category-added-successfully"));
        setNewCategoryName("");
        setNewCategoryNameAr("");
        dispatch(api.util.invalidateTags(["categories"]));
        setShow(false);
        setSubcategories([]);
        setOpen(false);
      })
      .catch((error) => {
        openToast(toastId, "add-category", "error", t(error.message));
      });
  };

  const handleCancel = () => {
    setShow(false);
    setNewCategoryName("");
    setNewCategoryNameAr("");
    setSubcategories([]);
    setOpen(false);
  };

  const handleEditCancel = () => {
    setEditFormShow(false);
    setEditingCategoryId(null);
  };

  const handleEditCategory = (categoryId) => {
    if (categories) {
      setEditingCategoryId(null);
      const selectedCategory = categories?.data?.categories?.find(
        (category) => category.id === categoryId,
      );
      if (selectedCategory) {
        setEditFormShow(true);
        setCategoryName(selectedCategory.name);
        setCategoryNameAr(
          selectedCategory.nameAr ? selectedCategory.nameAr : "",
        );
        setEditingCategoryId(selectedCategory.id);
        setSubcategories(selectedCategory.subcategories || []);
      }
    }
  };

  const handleUpdateAction = () => {
    if (!categoryName && !categoryNameAr) {
      openToast(toastId, "update-category", "error", t("fill-category-name"));
      return;
    }
    const formattedSubcategories = [];
    if (subcategories) {
      subcategories.map((sub) => {
        formattedSubcategories.push(sub.id);
      });
    }

    dispatch(
      editCategory({
        name: categoryName,
        nameAr: categoryNameAr,
        categoryId: editingCategoryId,
        subcategories: formattedSubcategories,
      }),
    )
      .unwrap()
      .then(() => {
        handleEditCancel();
        toast.success(t("category-updated-successfully"));
        dispatch(api.util.invalidateTags(["categories"]));
        setShow(false);
        setNewCategoryName("");
        setNewCategoryNameAr("");
        setSubcategories([]);
        setOpen(false);
      })
      .catch((error) => {
        openToast(toastId, "update-category", "error", t(error.message));
      });
  };

  return (
    <>
      <ContentContainer>
        <Row>
          <Text>{t("categories.categories")}:</Text>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="categories">
              {(provided) => (
                <Categories
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {categoriesPending ? (
                    <AppLoader />
                  ) : (
                    categories?.data?.categories?.map((category, index) => (
                      <Draggable
                        key={category.id}
                        draggableId={category.id.toString()}
                        index={index}
                      >
                        {(provided) => (
                          <RowCategory
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <Drag />
                            <Category>
                              <Value>{category.name}</Value>
                            </Category>
                            <IconsContainer>
                              {deleteCategoryLoading &&
                              selectedCategory === category.id ? (
                                <AppLoader />
                              ) : (
                                <UseAnimations
                                  className="pointer"
                                  animation={trash2}
                                  size={32}
                                  strokeColor="#484888"
                                  onClick={() =>
                                    handleCategoryDelete(category.id)
                                  }
                                />
                              )}
                              <EditPencil
                                className="edit-icon"
                                fill="#484888"
                                onClick={() => {
                                  setEditFormShow(true);
                                  handleEditCategory(category.id);
                                  setShow(false);
                                }}
                                style={{
                                  marginTop: 6,
                                  width: 26,
                                  height: 26,
                                  cursor: "pointer",
                                }}
                              />
                            </IconsContainer>
                          </RowCategory>
                        )}
                      </Draggable>
                    ))
                  )}
                  {provided.placeholder}
                </Categories>
              )}
            </Droppable>
          </DragDropContext>
          <IconsContainer style={{ marginTop: 3 }}>
            <Add
              onClick={() => {
                setShow(true);
                setEditFormShow(false);
              }}
              className="pointer"
            />
          </IconsContainer>
          {show && (
            <DivColumn>
              <AddCategoryContainer>
                <Text>Add Category</Text>
                <Input
                  type="text"
                  placeholder={t("category-name")}
                  value={newCategoryName}
                  onChange={(e) => setNewCategoryName(e.target.value)}
                />
                <Input
                  type="text"
                  placeholder={t("category-arabic-name")}
                  value={newCategoryNameAr}
                  onChange={(e) => setNewCategoryNameAr(e.target.value)}
                />
                {
                  <ButtonComponent
                    title={t("add")}
                    loading={createCategoryLoading}
                    onClick={handleAddCategory}
                  />
                }

                <ButtonComponent title={t("cancel")} onClick={handleCancel} />
              </AddCategoryContainer>
              <RowInputBig>
                <Text>{t("add-subcategory")}:</Text>
                <Relative>
                  <DropDown
                    $open={open}
                    onClick={() => setOpen(!open)}
                    style={{ maxHeight: 30 }}
                  >
                    <DropDownValue style={{ fontSize: 16 }}>
                      {t("select-subcategory")}
                    </DropDownValue>
                    <Chevron width={18} height={18} />
                  </DropDown>
                  {open && (
                    <DropDownMenu>
                      {availableSubcategories?.map((category, index) => (
                        <Attributes
                          style={{ fontSize: 16 }}
                          $active={subcategories.some(
                            (s) => s.id === category.id,
                          )}
                          key={index}
                          onClick={() => {
                            if (
                              subcategories.some((s) => s.id === category.id)
                            ) {
                              return;
                            } else {
                              setSubcategories([category, ...subcategories]);
                            }
                          }}
                        >
                          {category.name}
                        </Attributes>
                      ))}
                    </DropDownMenu>
                  )}
                </Relative>
              </RowInputBig>
              <StyledColumn>
                {subcategories.map((subcategory) => (
                  <StyledRow>
                    <span key={subcategory.id}>{subcategory.name}</span>
                    <UseAnimations
                      className="pointer"
                      animation={trash2}
                      size={26}
                      strokeColor="#484888"
                      onClick={() =>
                        setSubcategories(
                          subcategories.filter((s) => s.id !== subcategory.id),
                        )
                      }
                    />
                  </StyledRow>
                ))}
              </StyledColumn>
            </DivColumn>
          )}
          {editFormShow && (
            <AddCategoryContainer>
              <Text>{t("edit-category")}</Text>
              <Input
                type="text"
                placeholder={t("edit-category-name")}
                value={categoryName}
                onChange={(e) => setCategoryName(e.target.value)}
              />
              <Input
                type="text"
                placeholder={t("edit-category-arabic-name")}
                value={categoryNameAr}
                onChange={(e) => setCategoryNameAr(e.target.value)}
              />

              <ButtonComponent
                title={t("edit")}
                loading={editCategoryLoading}
                onClick={() => handleUpdateAction()}
              />
              <ButtonComponent
                title={t("cancel")}
                onClick={() => handleEditCancel()}
              />
              <RowInputBig>
                <Text>{t("add-subcategory")}:</Text>
                <Relative>
                  <DropDown
                    $open={open}
                    onClick={() => setOpen(!open)}
                    style={{ maxHeight: 30 }}
                  >
                    <DropDownValue style={{ fontSize: 16 }}>
                      {t("select-subcategory")}
                    </DropDownValue>
                    <Chevron width={18} height={18} />
                  </DropDown>
                  {open && (
                    <DropDownMenu>
                      {availableSubcategories?.map((category, index) => (
                        <Attributes
                          style={{ fontSize: 16 }}
                          $active={subcategories.some(
                            (s) => s.id === category.id,
                          )}
                          key={index}
                          onClick={() => {
                            if (
                              subcategories.some((s) => s.id === category.id)
                            ) {
                              return;
                            } else {
                              setSubcategories([category, ...subcategories]);
                            }
                          }}
                        >
                          {category.name}
                        </Attributes>
                      ))}
                    </DropDownMenu>
                  )}
                </Relative>
              </RowInputBig>
              <StyledColumn>
                {subcategories.map((subcategory) => (
                  <StyledRow>
                    <span key={subcategory.id}>{subcategory.name}</span>
                    <UseAnimations
                      className="pointer"
                      animation={trash2}
                      size={26}
                      strokeColor="#484888"
                      onClick={() => {
                        setSubcategories(
                          subcategories.filter((s) => s.id !== subcategory.id),
                        );
                      }}
                    />
                  </StyledRow>
                ))}
              </StyledColumn>
            </AddCategoryContainer>
          )}
        </Row>
      </ContentContainer>
      <Buttons>
        <ButtonBack onClick={() => navigate("/admin-portal/marketplace")}>
          {t("back")}
        </ButtonBack>
      </Buttons>
    </>
  );
};

export default CategoryStep1;
